namespace RioERP.Orders {
    export interface InstamojoSettingsRow {
        Id?: number;
        ClientId?: string;
        ClientSecret?: string;
        WebhookUrl?: string;
        RedirectUrl?: string;
        TransactionIdPrefix?: string;
        Currency?: Web.Enums.Currency;
        IsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace InstamojoSettingsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ClientId';
        export const localTextPrefix = 'Orders.InstamojoSettings';
        export const lookupKey = 'Orders.InstamojoSettings';

        export function getLookup(): Q.Lookup<InstamojoSettingsRow> {
            return Q.getLookup<InstamojoSettingsRow>('Orders.InstamojoSettings');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ClientId = "ClientId",
            ClientSecret = "ClientSecret",
            WebhookUrl = "WebhookUrl",
            RedirectUrl = "RedirectUrl",
            TransactionIdPrefix = "TransactionIdPrefix",
            Currency = "Currency",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
